// @ts-ignore - Cesium module resolution issue
import * as Cesium from 'cesium';
export const loadPlacemark = (artifactId, data, metadata, deps) => {
    var _a;
    const { viewer, artifactActions, addStatus } = deps;
    try {
        const metadataJson = JSON.parse(metadata.getMetadata());
        let longitude, latitude, altitude = 0;
        let elevationValue;
        let extremumKind;
        if (metadataJson.longitude !== undefined && metadataJson.latitude !== undefined) {
            longitude = metadataJson.longitude;
            latitude = metadataJson.latitude;
            altitude = metadataJson.altitude || 0;
        }
        else if (metadataJson.coordinates && Array.isArray(metadataJson.coordinates)) {
            longitude = metadataJson.coordinates[0];
            latitude = metadataJson.coordinates[1];
            altitude = metadataJson.coordinates[2] || 0;
        }
        else if (metadataJson.point) {
            longitude = metadataJson.point.longitude || metadataJson.point.lng;
            latitude = metadataJson.point.latitude || metadataJson.point.lat;
            altitude = metadataJson.point.altitude || 0;
        }
        else {
            const dataString = new TextDecoder().decode(data);
            try {
                const obj = JSON.parse(dataString);
                if (typeof obj.longitude === 'number' && typeof obj.latitude === 'number') {
                    longitude = obj.longitude;
                    latitude = obj.latitude;
                    altitude = typeof obj.altitude === 'number' ? obj.altitude : 0;
                    if (typeof obj.value === 'number')
                        elevationValue = obj.value;
                    if (typeof obj.kind === 'string')
                        extremumKind = obj.kind;
                }
            }
            catch (_) { }
            if (longitude === undefined || latitude === undefined) {
                const coordsMatch = dataString.match(/<coordinates>([^<]+)<\/coordinates>/);
                if (coordsMatch) {
                    const coords = coordsMatch[1].trim().split(',');
                    longitude = parseFloat(coords[0]);
                    latitude = parseFloat(coords[1]);
                    altitude = coords[2] ? parseFloat(coords[2]) : 0;
                }
            }
            if (longitude === undefined || latitude === undefined) {
                const goMapCoordsMatch = dataString.match(/coordinates:([^\s\]]+)/);
                if (goMapCoordsMatch) {
                    const coords = goMapCoordsMatch[1].split(',');
                    longitude = parseFloat(coords[0]);
                    latitude = parseFloat(coords[1]);
                    altitude = coords[2] ? parseFloat(coords[2]) : 0;
                }
            }
            if (typeof longitude !== 'number' || typeof latitude !== 'number' || isNaN(longitude) || isNaN(latitude)) {
                addStatus(`No coordinate data found for placemark: ${metadata.getName()}`);
                console.error('Metadata:', metadataJson);
                console.error('Data:', dataString);
                return;
            }
        }
        if (typeof longitude === 'number' && typeof latitude === 'number') {
            if ((Math.abs(latitude) > 90 && Math.abs(longitude) <= 180) || (Math.abs(longitude) <= 90 && Math.abs(latitude) > 90)) {
                const tmp = longitude;
                longitude = latitude;
                latitude = tmp;
            }
        }
        if (typeof longitude !== 'number' || typeof latitude !== 'number' || isNaN(longitude) || isNaN(latitude)) {
            addStatus(`Invalid position data for placemark: ${metadata.getName()}`);
            console.error('Parsed coordinates:', { longitude, latitude, altitude });
            return;
        }
        let labelText = metadata.getName();
        if (typeof elevationValue === 'number') {
            const kindText = extremumKind === 'min' ? 'Min' : (extremumKind === 'max' ? 'Max' : 'Elevation');
            labelText = `${kindText} Elevation: ${elevationValue.toFixed(2)} m`;
        }
        const entity = viewer.entities.add({
            id: artifactId,
            position: Cesium.Cartesian3.fromDegrees(longitude, latitude, altitude),
            billboard: {
                image: 'data:image/svg+xml;base64,' + btoa(`
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" fill="#dc2626" stroke="#991b1b"/>
            <circle cx="12" cy="10" r="3" fill="white" stroke="#991b1b"/>
          </svg>
        `),
                scale: 0.8,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                disableDepthTestDistance: Number.POSITIVE_INFINITY
            },
            label: {
                text: labelText,
                font: '12pt sans-serif',
                pixelOffset: new Cesium.Cartesian2(0, -50),
                fillColor: Cesium.Color.WHITE,
                outlineColor: Cesium.Color.BLACK,
                outlineWidth: 2,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                show: false
            }
        });
        try {
            const parts = [];
            if (typeof elevationValue === 'number') {
                const kindText = extremumKind === 'min' ? 'Minimum' : (extremumKind === 'max' ? 'Maximum' : 'Elevation');
                parts.push(`<p><strong>${kindText} Elevation:</strong> ${elevationValue.toFixed(2)} m</p>`);
            }
            parts.push(`<p><strong>Location:</strong> ${latitude.toFixed(6)}, ${longitude.toFixed(6)}</p>`);
            entity.description = new Cesium.ConstantProperty(parts.join('\n'));
        }
        catch (_) { }
        entity.show = true;
        try {
            const props = {
                name: metadata.getName(),
                longitude: longitude,
                latitude: latitude,
                altitude: altitude
            };
            if (elevationValue !== undefined)
                props.elevation = elevationValue;
            if (typeof metadata.getMetadata === 'function') {
                try {
                    const metaStr = metadata.getMetadata();
                    if (metaStr)
                        props.description = ((_a = JSON.parse(metaStr)) === null || _a === void 0 ? void 0 : _a.description) || '';
                }
                catch (_b) { }
            }
            entity.properties = new Cesium.PropertyBag(props);
        }
        catch (_) { }
        artifactActions.updateLoaded(artifactId, {
            type: 'placemark',
            cesiumObject: entity,
            metadata: metadata
        });
        artifactActions.resetRetryCount(artifactId);
        artifactActions.updateVisibility(artifactId, true);
        artifactActions.setLoading(artifactId, false);
    }
    catch (error) {
        artifactActions.setLoading(artifactId, false);
        addStatus(`Error creating placemark: ${error}`);
    }
};
